<template lang="pug">
.v-collection-slider.collection-slider
	.container
		v-loader(:loading="!swiper")
		.collection-slider__header
			component.collection-slider__title(:is="data?.titleLevel ? data?.titleLevel : 'h3'" v-if="data && data.title" :class="data?.titleStyleLevel") {{ data.title }}
			.collection-slider__buttons
				button.collection-slider__button.slider-btn.left(ref="prev")
				button.collection-slider__button.slider-btn.right(ref="next")
		v-swiper-slider(v-if="data && data.items && data.items.length"
			:options="{...options, freeMode: isSm}"
			:navigation="navigation"
			@swiper="onSwiper")
			swiper-slide.collection-slider__slide(v-for="(item, index) in data.items" :key="index")
				v-collection-card(:data-source="item")
</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';
	import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
	import breakpoints from '../scripts/breakpoints.js';
	import uniqueId from '../scripts/helpers/uniqueId.js';
	import {SwiperSlide} from "swiper/vue";

	export default {
		components: {
			SwiperSlide,
		},

		mixins: [
			sourceMixin,
			isMobMixin
		],
		data() {
			return {
				data: {},
				swiper: null,
				uniqueId: uniqueId('swiper-'),
				options: {
					slidesPerView: 2.3,
					spaceBetween: 40,
					a11y: {
						prevSlideMessage: 'Предыдущий слайд',
						nextSlideMessage: 'Следующий слайд',
					},
					breakpoints: {
						[breakpoints['sm-max']]: {
							slidesPerView: 2.3
						},
						[breakpoints['4xs-min']]: {
							slidesPerView: 1.09,
							spaceBetween: 12,
						}
					},
					navigation: false
				}
			}
		},
		methods: {
			dataSet(data) {
				this.data = data;
			},
			onSwiper(swiper) {
				this.navigation = {
					prevEl: this.$refs['prev'],
					nextEl: this.$refs['next']
				};
				this.swiper = swiper;
			}
		}
	}

</script>